import { Box } from '@mui/material';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import SimpleModal from 'components/SimpleModal';
import { useCallback } from 'react';

export const useForceProvisionConfirmationModal = () => {
  const { openModal } = useDynamicModal();

  const openForceProvisionConfirmationModal = useCallback(
    ({ onConfirm }: { onConfirm: VoidFunction }) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return (
            <SimpleModal
              onClose={toggle}
              open
              onConfirm={onConfirm}
              closeOnConfirm
              Body={
                <div>
                  <Box
                    sx={{
                      marginY: 5,
                    }}
                  >
                    Are you sure you want to proceed with force provisioning?
                  </Box>
                  <Box
                    sx={{
                      marginY: 5,
                    }}
                  >
                    A force-created integration will require further manual fixes to function
                    properly.
                  </Box>
                </div>
              }
            />
          );
        },
      });
    },
    [openModal],
  );
  return {
    openForceProvisionConfirmationModal,
  };
};
